/* eslint-disable */
export default {
  unknown: 'Desconocido',
  anonymous: 'Anónimo',
  activeCall: 'Llamada activa',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
